module.exports = require("http");


/*****************
 ** WEBPACK FOOTER
 ** external "http"
 ** module id = 390
 ** module chunks = 0
 **/